// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================================
   Vendor Quote Requests — Styles
   ========================================================================= */

/* Tabs */
.vqr-tabs .nav-link {
  color: #666;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-right: 6px;
  transition: all 0.2s ease;
}
.vqr-tabs .nav-link.active {
  background: #ff385c;
  color: #fff;
}
.vqr-tabs .nav-link:hover:not(.active) {
  background: #fff0f2;
  color: #ff385c;
}

/* Request Cards */
.vqr-request-card {
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.vqr-request-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.vqr-card-desc {
  color: #1c1c1c;
  font-size: 0.95rem;
  line-height: 1.4;
}
.vqr-card-meta {
  font-size: 0.78rem;
  color: #93959f;
}
.vqr-card-meta i {
  color: #b0b3b8;
}
.vqr-category-badge {
  background: #f0f0ff;
  color: #5b5fc7;
  font-weight: 600;
  font-size: 0.72rem;
  border-radius: 6px;
  padding: 4px 10px;
}

/* My Quote Cards */
.vqr-myquote-card {
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.vqr-quote-price {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1c1c1c;
}

/* Order Cards */
.vqr-order-card {
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-left: 4px solid #28a745 !important;
  transition: all 0.2s ease;
}
.vqr-order-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
.vqr-order-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #f0f0f0;
}
.vqr-order-info i {
  color: #6c757d;
  width: 16px;
}

/* Notification Cards */
.vqr-notif-card {
  border-radius: 8px;
  border: none;
  transition: background 0.2s;
}
.vqr-notif-unread {
  background: #fff8f9;
  border-left: 3px solid #ff385c;
}
.vqr-notif-read {
  background: #f8f8f8;
  border-left: 3px solid transparent;
}

/* Toast */
.vqr-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 24px;
  color: #fff;
  border-radius: 8px;
  font-size: 0.88rem;
  z-index: 10000;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.vqr-toast.show {
  opacity: 1;
  transform: translateY(0);
}

/* Responsive */
@media (max-width: 768px) {
  .vqr-quote-price {
    font-size: 1.1rem;
  }
  .vqr-tabs .nav-link {
    font-size: 0.78rem;
    padding: 5px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/vendorQuoteRequests.css"],"names":[],"mappings":"AAAA;;8EAE8E;;AAE9E,SAAS;AACT;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,yCAAyC;EACzC,yBAAyB;AAC3B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":["/* =========================================================================\r\n   Vendor Quote Requests — Styles\r\n   ========================================================================= */\r\n\r\n/* Tabs */\r\n.vqr-tabs .nav-link {\r\n  color: #666;\r\n  border-radius: 20px;\r\n  padding: 6px 16px;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  margin-right: 6px;\r\n  transition: all 0.2s ease;\r\n}\r\n.vqr-tabs .nav-link.active {\r\n  background: #ff385c;\r\n  color: #fff;\r\n}\r\n.vqr-tabs .nav-link:hover:not(.active) {\r\n  background: #fff0f2;\r\n  color: #ff385c;\r\n}\r\n\r\n/* Request Cards */\r\n.vqr-request-card {\r\n  border-radius: 12px;\r\n  border: 1px solid #f0f0f0;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n.vqr-request-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n}\r\n.vqr-card-desc {\r\n  color: #1c1c1c;\r\n  font-size: 0.95rem;\r\n  line-height: 1.4;\r\n}\r\n.vqr-card-meta {\r\n  font-size: 0.78rem;\r\n  color: #93959f;\r\n}\r\n.vqr-card-meta i {\r\n  color: #b0b3b8;\r\n}\r\n.vqr-category-badge {\r\n  background: #f0f0ff;\r\n  color: #5b5fc7;\r\n  font-weight: 600;\r\n  font-size: 0.72rem;\r\n  border-radius: 6px;\r\n  padding: 4px 10px;\r\n}\r\n\r\n/* My Quote Cards */\r\n.vqr-myquote-card {\r\n  border-radius: 12px;\r\n  border: 1px solid #f0f0f0;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n}\r\n.vqr-quote-price {\r\n  font-size: 1.3rem;\r\n  font-weight: 700;\r\n  color: #1c1c1c;\r\n}\r\n\r\n/* Order Cards */\r\n.vqr-order-card {\r\n  border-radius: 12px;\r\n  border: 1px solid #e0e0e0;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  border-left: 4px solid #28a745 !important;\r\n  transition: all 0.2s ease;\r\n}\r\n.vqr-order-card:hover {\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\r\n}\r\n.vqr-order-info {\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  padding: 10px;\r\n  border: 1px solid #f0f0f0;\r\n}\r\n.vqr-order-info i {\r\n  color: #6c757d;\r\n  width: 16px;\r\n}\r\n\r\n/* Notification Cards */\r\n.vqr-notif-card {\r\n  border-radius: 8px;\r\n  border: none;\r\n  transition: background 0.2s;\r\n}\r\n.vqr-notif-unread {\r\n  background: #fff8f9;\r\n  border-left: 3px solid #ff385c;\r\n}\r\n.vqr-notif-read {\r\n  background: #f8f8f8;\r\n  border-left: 3px solid transparent;\r\n}\r\n\r\n/* Toast */\r\n.vqr-toast {\r\n  position: fixed;\r\n  top: 20px;\r\n  right: 20px;\r\n  padding: 12px 24px;\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  font-size: 0.88rem;\r\n  z-index: 10000;\r\n  opacity: 0;\r\n  transform: translateY(-10px);\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n.vqr-toast.show {\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .vqr-quote-price {\r\n    font-size: 1.1rem;\r\n  }\r\n  .vqr-tabs .nav-link {\r\n    font-size: 0.78rem;\r\n    padding: 5px 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
